class DrawerMenuItem extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.originHeight = parseInt(this.getAttribute("origin-height") || "63");
    this.fullHeight = 0;
    this.toggleButton = null;
    this.content = null;
  }

  setHeight() {
    this.fullHeight = this.clientHeight;
    this.style.height = `${this.originHeight}px`;
  }

  connectedCallback() {
    // Get elements
    this.toggleButton = this.querySelector('.toggle-button');
    this.content = this.querySelector(".content");

    // Add event listener only to toggle button
    if (this.toggleButton) {
      this.toggleButton.addEventListener("click", this.toggle.bind(this));
    }
  }

  toggle() {
    this.isOpen = !this.isOpen;

    console.log("toggle", this.fullHeight, this.originHeight);

    // Toggle arrow rotation
    const arrow = this.querySelector('[data-arrow]');
    if (arrow) {
      if (this.isOpen) {
        arrow.style.transform = 'rotate(180deg)';
      } else {
        arrow.style.transform = 'rotate(0deg)';
      }
    }

    if (this.isOpen) {
      this.style.height = `${this.fullHeight}px`;
    } else {
      this.style.height = `${this.originHeight}px`;
    }
  }

  disconnectedCallback() {
    // Clean up event listeners
    if (this.toggleButton) {
      this.toggleButton.removeEventListener("click", this.toggle);
    }
  }
}

// Register custom element
if (!customElements.get("drawer-menu-item")) {
  customElements.define("drawer-menu-item", DrawerMenuItem);
}

class NavMegaItem extends HTMLElement {
  constructor() {
    super();
    this.timeout = 0;
    this.openTimer = null;
    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener("mouseenter", this.handleMouseEnter.bind(this));
    this.addEventListener("click", this.handleClick.bind(this));
    this.addEventListener("mouseleave", this.handleMouseLeave.bind(this));

    const megaMenu = this.querySelector(".mega-menu");
    if (megaMenu) {
      megaMenu.addEventListener("mouseleave", this.handleMouseLeave.bind(this));
    }
  }

  closeMenu() {
    const megaMenu = this.querySelector(".mega-menu");
    if (!megaMenu) return;

    megaMenu.classList.remove("animated");
    setTimeout(() => {
      megaMenu.classList.remove("show");
      document.body.classList.remove("no-scroll");
    }, 300);
  }

  openMenu() {
    const megaMenu = this.querySelector(".mega-menu");
    if (!megaMenu) return;

    clearTimeout(this.timeout);
    this.openTimer = setTimeout(() => {
      megaMenu.classList.add("show");
      setTimeout(() => {
        megaMenu.classList.add("animated");
      }, 10);
    }, 300);
    document.body.classList.add("no-scroll");
  }

  handleMouseEnter(event) {
    event.stopPropagation();
    this.openMenu();
  }

  handleClick(event) {
    event.stopPropagation();
    const megaMenu = this.querySelector(".mega-menu");
    if (!megaMenu) return;

    if (megaMenu.classList.contains("show")) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  handleMouseLeave(event) {
    event.stopPropagation();
    const megaMenu = this.querySelector(".mega-menu");
    if (!megaMenu) return;

    const relatedTarget = event.relatedTarget;

    // 如果鼠标进入了 mega-menu 或主菜单项，不关闭菜单
    if (
      relatedTarget &&
      (megaMenu.contains(relatedTarget) || this.contains(relatedTarget))
    ) {
      return;
    }

    clearTimeout(this.openTimer);
    this.timeout = setTimeout(() => {
      this.closeMenu();
    }, 500);
  }
}

// Register the custom element
if (!customElements.get("nav-mega-item")) {
  customElements.define("nav-mega-item", NavMegaItem);
}

// Initialize all nav-mega-items on the page
document.addEventListener("DOMContentLoaded", () => {
  // Convert the nav-mega-item class elements to custom elements
  document.querySelectorAll(".nav-mega-item").forEach((item) => {
    // The browser already created instances of the custom element
    // if properly marked with is="nav-mega-item", but we handle both cases
    if (!(item instanceof NavMegaItem)) {
      Object.setPrototypeOf(item, NavMegaItem.prototype);
      NavMegaItem.call(item);
    }
  });
});

if (!customElements.get("header-menu")) {
  customElements.define(
    "header-menu",
    class extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const announcementBar = document.querySelector("#announcement-bar");

        // Calculate and set scrollbar width
        this.calculateScrollbarWidth();

        // 创建 MutationObserver 监听 announcement bar 高度变化
        this.setupAnnouncementBarObserver();

        this.querySelectorAll(["[data-search-icon]"]).forEach((item) => {
          console.log(item);
          item.addEventListener("click", () => {
            this.openSearchPanel();
          });
        });
      }

      openSearchPanel() {
        const searchField = this.querySelector(".header-searchField");
        const searchWrapper = this.querySelector(".header-searchField-wrapper");
        const searchInput = searchField.querySelector("input[type='search']");
        const announcementBar = document.querySelector("#announcement-bar");

        // Toggle search panel
        searchField.classList.toggle("active");
        searchWrapper.classList.toggle("active");

        // Hide/show announcement bar
        if (searchField.classList.contains("active")) {
          // Hide announcement bar when search is opened
          if (announcementBar) {
            announcementBar.style.display = "none";
            // Update header position
            this.updateHeaderTop();
          }
          // Auto-focus the search input when opening
          if (searchInput) {
            setTimeout(() => {
              searchInput.focus();
            }, 100);
          }
        } else {
          // Show announcement bar when search is closed
          if (announcementBar) {
            announcementBar.style.display = "block";
            // Update header position
            this.updateHeaderTop();
          }
        }

        if (searchWrapper.classList.contains("active")) {
          if (this.classList.contains("headroom--pinned")) {
            this.classList.remove("headroom--pinned");
          }

          if (!this.classList.contains("headroom--unpinned")) {
            this.classList.add("headroom--unpinned");
          }
        }
      }

      calculateScrollbarWidth() {
        // Create a temporary div to measure scrollbar width
        const outer = document.createElement("div");
        outer.style.visibility = "hidden";
        outer.style.overflow = "scroll";
        outer.style.msOverflowStyle = "scrollbar";
        document.body.appendChild(outer);

        const inner = document.createElement("div");
        outer.appendChild(inner);

        const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
        outer.parentNode.removeChild(outer);

        // Set the CSS variable
        document.documentElement.style.setProperty(
          "--scrollbar-width",
          `${scrollbarWidth}px`,
        );
      }

      setupAnnouncementBarObserver() {
        const announcementBar = document.querySelector("#announcement-bar");
        if (!announcementBar) return;

        // 初始设置
        this.updateHeaderTop();

        // 创建 MutationObserver 监听高度变化
        const observer = new MutationObserver(() => {
          this.updateHeaderTop();
        });

        // 监听属性变化（如 style 属性）
        observer.observe(announcementBar, {
          attributes: true,
          attributeFilter: ["style", "class"],
          subtree: true,
        });

        // 监听子元素变化（可能影响高度）
        observer.observe(announcementBar, {
          childList: true,
          subtree: true,
        });

        // 使用 ResizeObserver 监听尺寸变化（更准确）
        let resizeObserver = null;
        if (window.ResizeObserver) {
          resizeObserver = new ResizeObserver(() => {
            this.updateHeaderTop();
          });
          resizeObserver.observe(announcementBar);
        }

        // 存储 observer 以便后续清理
        this.announcementObserver = observer;
        this.announcementResizeObserver = resizeObserver;
      }

      updateHeaderTop() {
        const announcementBar = document.querySelector("#announcement-bar");
        console.log(announcementBar.clientHeight);
        const announcementHeight =
          announcementBar && announcementBar.clientHeight > 0
            ? announcementBar.clientHeight
            : 0;

        // 设置当前元素的 top 位置
        this.style.top = `${announcementHeight}px`;

        // 也可以设置 CSS 变量供其他元素使用
        document.documentElement.style.setProperty(
          "--announcement-height",
          `${announcementHeight}px`,
        );
      }

      disconnectedCallback() {
        // 清理 observers
        if (this.announcementObserver) {
          this.announcementObserver.disconnect();
        }
        if (this.announcementResizeObserver) {
          this.announcementResizeObserver.disconnect();
        }
      }
    },
  );
}
